var Dlrt;
(function (Dlrt) {
    class EnvironmentImpl {
        constructor(locale) {
            this.locale = locale;
        }
        get Locale() {
            return this.locale;
        }
    }
    Dlrt.EnvironmentImpl = EnvironmentImpl;
    function InitEnvironment(locale) {
        Dlrt.Environment = new EnvironmentImpl(locale);
    }
    Dlrt.InitEnvironment = InitEnvironment;
})(Dlrt || (Dlrt = {}));

//# sourceMappingURL=Environment.js.map
